import { render, staticRenderFns } from "./AccountOptions.vue?vue&type=template&id=18c060eb&scoped=true&"
import script from "./AccountOptions.vue?vue&type=script&lang=ts&"
export * from "./AccountOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c060eb",
  null
  
)

export default component.exports